module.exports = __webpack_public_path__ + "static/media/booth.e688c05b.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/icon/booth.png
// module id = 276
// module chunks = 0